import React from "react";
import { arabicDigits } from "../../utils/arabicNumbers";

/**
 * VotePill — the mockup's horizontal vote control: ▲ count ▼ in a raised
 * pill. In RTL the DOM order puts ▲ on the right, ▼ on the left. Up-active
 * is gold; down-active mirrors in the flag/rose tone (the mockup never
 * designed a down state — this is its symmetric counterpart).
 *
 * onVote(direction) is DECLARATIVE at the caller: clicking the active
 * direction clears the vote (MajlisPage computes desired end state).
 *
 * Props: myVote (1|0|-1), score, onVote(direction), disabled.
 */
export default function VotePill({ myVote = 0, score = 0, onVote, disabled = false }) {
  const voteBtn = (direction, glyph, activeColor, label) => {
    const active = myVote === direction;
    return (
      <button
        onClick={() => onVote && onVote(direction)}
        disabled={disabled || !onVote}
        className="w-7 h-7 rounded-full grid place-items-center text-[15px] disabled:opacity-40"
        style={{ color: active ? activeColor : "var(--mj-muted)" }}
        onMouseEnter={(e) => {
          if (!active) {
            e.currentTarget.style.background = "var(--mj-ink-6)";
            e.currentTarget.style.color = "var(--mj-cream)";
          }
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "transparent";
          e.currentTarget.style.color = active ? activeColor : "var(--mj-muted)";
        }}
        aria-label={label}
        aria-pressed={active}
      >
        {glyph}
      </button>
    );
  };

  return (
    <div
      className="flex items-center gap-2 rounded-full px-1.5 py-1 text-[13px] font-bold font-plex"
      style={{ background: "var(--mj-raised)" }}
    >
      {voteBtn(1, "▲", "var(--mj-gold)", "صوّت لأعلى")}
      <span
        className="min-w-[26px] text-center"
        style={{
          color:
            myVote === 1 ? "var(--mj-gold)" : myVote === -1 ? "var(--mj-flag)" : "var(--mj-cream)",
        }}
      >
        {arabicDigits(score)}
      </span>
      {voteBtn(-1, "▼", "var(--mj-flag)", "صوّت لأسفل")}
    </div>
  );
}
